import { StyledCol, StyledRow, StyledFormContainer } from "./index.styled";

export const Row = (props) => {
  return (
    <StyledRow
      gap={props.gap || "25px"}
      columnGap={props.columnGap || "50px"}
      rowGap={props.rowGap || "50px"}
      marginBottom={props.marginBottom || "25px"}
      marginRight={props.marginRight || "25px"}
      align={props.align || "end"}
      break={props.break}
    >
      {props.children}
    </StyledRow>
  );
};

export const Col = (props) => {
  return <StyledCol columns={props.columns}>{props.children}</StyledCol>;
};

export const FormContainer = (props) => {
  return (
    <StyledFormContainer align={props.align || "end"}>
      {props.children}
    </StyledFormContainer>
  );
};
